<ng-container *ngTemplateOutlet="currentView"></ng-container>
<ng-content></ng-content>